import React from 'react'
import { useTranslation } from 'react-i18next'
import { ExclamationIcon } from '@heroicons/react/outline'

// Defense-in-depth dialog (§8.6): shown when the server rejects label generation
// with `422 { code: 'packing_audit_required' }` despite the local UI check (e.g. a
// stale cache). Same blocking shape as CameraBlockedDialog. The single action
// acknowledges and refreshes the order so the audit block re-renders.
//
// The backdrop is positioned `absolute inset-0` to cover only the PageView content
// area, relying on PageView's `relative` wrapper as the positioned ancestor.
export const PackingAuditBlockedDialog = ({ open, onAcknowledge }) => {
  const { t } = useTranslation()

  if (!open) return null

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="packing-audit-blocked-title"
      aria-describedby="packing-audit-blocked-description"
      className="absolute inset-0 z-20 flex items-center justify-center p-4 bg-gray-500 bg-opacity-75"
    >
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full p-6">
        <div className="sm:flex sm:items-start">
          <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <ExclamationIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
          </div>
          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 id="packing-audit-blocked-title" className="text-lg leading-6 font-medium text-gray-900">
              {t('packing_audit.label_blocked.title')}
            </h3>
            <div id="packing-audit-blocked-description" className="mt-2">
              <p className="text-sm text-gray-700">
                {t('packing_audit.label_blocked.message')}
              </p>
            </div>
          </div>
        </div>
        <div className="mt-5 sm:mt-6 sm:flex sm:flex-row-reverse">
          <button
            type="button"
            onClick={onAcknowledge}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:w-auto sm:text-sm"
          >
            {t('common.accept')}
          </button>
        </div>
      </div>
    </div>
  )
}
